export default __webpack_public_path__ + "static/media/submenu-gray.bb97c620.svg";